import { render, staticRenderFns } from "./pedido.vue?vue&type=template&id=4e6892d8&scoped=true&"
import script from "./pedido.vue?vue&type=script&lang=ts&"
export * from "./pedido.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6892d8",
  null
  
)

export default component.exports